import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const COLLECTIONS_ROUTES: RouteObject[] = [
  {
    path: 'collections',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'pending-recharges',
        lazy: async () => {
          const PendingRechargesPage = lazy(
            () => import('@/pages/pendingRecharges/PendingRechargesPage.tsx')
          )
          return { element: <PendingRechargesPage /> }
        }
      },
      {
        path: 'late-quotas',
        lazy: async () => {
          const LateQuotasPage = lazy(
            () => import('@/pages/lateQuotas/LateQuotasPage.tsx')
          )
          return { element: <LateQuotasPage /> }
        }
      }
    ]
  }
]

export default COLLECTIONS_ROUTES
